/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ApplicationResponse,
    ApplicationResponseFromJSON,
    ApplicationResponseToJSON,
} from '../models/ApplicationResponse';
import {
    type MinSideAccessControl,
    MinSideAccessControlFromJSON,
    MinSideAccessControlToJSON,
} from '../models/MinSideAccessControl';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type UserOrganizationGroupResponse,
    UserOrganizationGroupResponseFromJSON,
    UserOrganizationGroupResponseToJSON,
} from '../models/UserOrganizationGroupResponse';

/**
 * 
 */
export class MeApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiMeAccessControlListGet without sending the request
     */
    async apiMeAccessControlListGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/me/access-control-list`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiMeAccessControlListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MinSideAccessControl>>> {
        const requestOptions = await this.apiMeAccessControlListGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MinSideAccessControlFromJSON));
    }

    /**
     */
    async apiMeAccessControlListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MinSideAccessControl>> {
        const response = await this.apiMeAccessControlListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiMeApplicationsGet without sending the request
     */
    async apiMeApplicationsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/me/applications`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiMeApplicationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationResponse>>> {
        const requestOptions = await this.apiMeApplicationsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationResponseFromJSON));
    }

    /**
     */
    async apiMeApplicationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationResponse>> {
        const response = await this.apiMeApplicationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiMeOrgnaizationGroupsGet without sending the request
     */
    async apiMeOrgnaizationGroupsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/me/orgnaization-groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiMeOrgnaizationGroupsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserOrganizationGroupResponse>>> {
        const requestOptions = await this.apiMeOrgnaizationGroupsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserOrganizationGroupResponseFromJSON));
    }

    /**
     */
    async apiMeOrgnaizationGroupsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserOrganizationGroupResponse>> {
        const response = await this.apiMeOrgnaizationGroupsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiMePhoneDelete without sending the request
     */
    async apiMePhoneDeleteRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/me/phone`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiMePhoneDeleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiMePhoneDeleteRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMePhoneDelete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMePhoneDeleteRaw(initOverrides);
    }

}
